/**
 * BASSERS® OUTFIT — 入場演出
 * 1) プリローダー（カウンター 000→100）→ パネルが上へ抜ける
 * 2) ワードマークの文字が 1 文字ずつ下からせり上がる、罫線が左から伸びる
 * 3) ヘッダー・情報行・見出しがフェードイン
 * 4) 商品サムネがグレー枠から順番にフェードイン（ビューポートに入ったとき）
 * prefers-reduced-motion のときは全てスキップ
 */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var html = document.documentElement;
  var cfg = window.outfitIntro || {};

  if (reduce || !cfg.enabled) {
    html.classList.remove('js-outfit-anim');
    var pre = document.querySelector('[data-outfit-preloader]');
    if (pre) pre.remove();
    return;
  }

  /* ---- 文字分割 ---- */
  function splitLetters(text) {
    if (text.dataset.outfitSplit) return;
    text.dataset.outfitSplit = '1';
    var nodes = Array.prototype.slice.call(text.childNodes);
    var frag = document.createDocumentFragment();
    nodes.forEach(function (n) {
      if (n.nodeType === 3) {
        Array.prototype.forEach.call(n.textContent, function (ch) {
          var w = document.createElement('span');
          w.className = 'outfit-letter';
          var inner = document.createElement('span');
          inner.className = 'outfit-letter__in';
          inner.textContent = ch === ' ' ? ' ' : ch;
          w.appendChild(inner);
          frag.appendChild(w);
        });
      } else {
        var w2 = document.createElement('span');
        w2.className = 'outfit-letter outfit-letter--reg';
        var inner2 = document.createElement('span');
        inner2.className = 'outfit-letter__in';
        inner2.appendChild(n.cloneNode(true));
        w2.appendChild(inner2);
        frag.appendChild(w2);
      }
    });
    text.innerHTML = '';
    text.appendChild(frag);
  }

  function revealWordmarks(baseDelay) {
    document.querySelectorAll('[data-outfit-wordmark]').forEach(function (wm) {
      var text = wm.querySelector('[data-outfit-wordmark-text]');
      if (!text) return;
      splitLetters(text);
      var letters = Array.prototype.slice.call(text.querySelectorAll('.outfit-letter__in'));
      // 参考サイトと同じく、文字はランダム順で 100ms ずらして上がる（順番は固定シードで毎回同じ）
      var order = letters.map(function (_, i) { return i; });
      var seed = 7;
      for (var k = order.length - 1; k > 0; k--) {
        seed = (seed * 9301 + 49297) % 233280;
        var r = Math.floor((seed / 233280) * (k + 1));
        var tmp = order[k]; order[k] = order[r]; order[r] = tmp;
      }
      order.forEach(function (idx, pos) {
        letters[idx].style.transitionDelay = (baseDelay + pos * 100) + 'ms';
      });
      wm.classList.add('is-ready');
      requestAnimationFrame(function () { wm.classList.add('is-in'); });
      var rule = wm.parentElement && wm.parentElement.querySelector('.outfit-rule');
      if (rule) {
        rule.style.transitionDelay = (baseDelay + 300) + 'ms';
        rule.classList.add('outfit-rule--draw');
        void rule.offsetWidth; /* 初期状態を確定させてから遷移 */
        requestAnimationFrame(function () { rule.classList.add('is-in'); });
      }
    });
  }

  function revealFades(baseDelay) {
    var items = document.querySelectorAll('[data-outfit-fade]');
    items.forEach(function (el, i) {
      el.style.transitionDelay = (baseDelay + i * 90) + 'ms';
      requestAnimationFrame(function () { el.classList.add('is-in'); });
    });
  }

  function revealCards(baseDelay) {
    var medias = Array.prototype.slice.call(document.querySelectorAll('.outfit-card, .outfit-featured__item--video, .outfit-hero__video, .outfit-product__media-item'));
    if (!medias.length) return;
    medias.forEach(function (m) { m.classList.add('outfit-reveal'); });
    void document.body.offsetWidth;
    var pending = medias.slice();
    var started = Date.now();
    function reveal(batch) {
      batch.forEach(function (m, i) {
        var elapsed = Date.now() - started;
        var delay = Math.max(0, baseDelay - elapsed) + i * 120;
        setTimeout(function () { m.classList.add('is-in'); }, delay);
      });
    }
    if (!('IntersectionObserver' in window)) { reveal(pending); return; }
    // 75% 下にずらした状態で判定すると画面外扱いになるため、ずれていない親枠（単独子のとき）を監視し、
    // 下方向の監視範囲も広げる
    var targetOf = new Map();
    pending.forEach(function (m) {
      var p = m.parentElement;
      var t = (p && p.children.length === 1 && !p.classList.contains('outfit-grid')) ? p : m;
      targetOf.set(t, m);
    });
    var io = new IntersectionObserver(function (entries) {
      var batch = [];
      entries.forEach(function (e) {
        if (e.isIntersecting) { batch.push(targetOf.get(e.target) || e.target); io.unobserve(e.target); }
      });
      batch.sort(function (a, b) { var ra = a.getBoundingClientRect(), rb = b.getBoundingClientRect(); return (ra.top - rb.top) || (ra.left - rb.left); });
      reveal(batch);
    }, { rootMargin: '0px 0px 45% 0px', threshold: 0.01 });
    targetOf.forEach(function (m, t) { io.observe(t); });
  }

  function runPage(baseDelay) {
    html.classList.add('outfit-anim-started');
    revealWordmarks(baseDelay);
    revealFades(baseDelay + 500);
    revealCards(baseDelay + 500);
  }

  /* ---- プリローダー ---- */
  function runPreloader(pre, done) {
    var counter = pre.querySelector('[data-outfit-counter]');
    var duration = (cfg.duration || 2.5) * 1000;
    var start = null;
    function ease(t) { return 1 - Math.pow(1 - t, 3); }
    function frame(ts) {
      if (!start) start = ts;
      var p = Math.min(1, (ts - start) / duration);
      if (counter) counter.textContent = String(Math.round(ease(p) * 100)).padStart(3, '0');
      if (p < 1) requestAnimationFrame(frame);
      else {
        setTimeout(function () {
          pre.classList.add('is-leaving');
          done();
          setTimeout(function () { pre.remove(); }, 1100);
        }, 150);
      }
    }
    requestAnimationFrame(frame);
  }

  function boot() {
    var pre = document.querySelector('[data-outfit-preloader]');
    var showPre = false;
    if (pre) {
      try {
        showPre = !(cfg.once && sessionStorage.getItem('outfitPreloaderShown'));
        if (showPre) sessionStorage.setItem('outfitPreloaderShown', '1');
      } catch (e) { showPre = true; }
      if (!showPre) pre.remove();
    }
    if (pre && showPre) {
      pre.classList.add('is-active');
      document.body.classList.add('outfit-preloading');
      runPreloader(pre, function () {
        document.body.classList.remove('outfit-preloading');
        runPage(550);
      });
    } else {
      runPage(100);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { revealCards(0); revealWordmarks(0); revealFades(0); });
})();
